export function createNarrativeUi() {
  const beat = document.createElement('div');
  beat.className = 'narrative-beat';
  beat.style.display = 'none';
  document.body.appendChild(beat);

  const quote = document.createElement('div');
  quote.className = 'narrative-quote';
  document.body.appendChild(quote);

  const historyWrap = document.createElement('div');
  historyWrap.className = 'history-wrap';
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'history-toggle';
  toggle.textContent = '本局简史';
  const panel = document.createElement('div');
  panel.className = 'history-panel';
  panel.style.display = 'none';
  historyWrap.appendChild(toggle);
  historyWrap.appendChild(panel);
  document.body.appendChild(historyWrap);

  let open = false;
  let beatUntil = 0;

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    open = !open;
    panel.style.display = open ? 'block' : 'none';
    toggle.classList.toggle('active', open);
  });

  return {
    setQuote(text) {
      quote.textContent = text;
    },
    showBeat(text, ms = 2200) {
      beat.textContent = text;
      beat.style.display = 'block';
      beatUntil = performance.now() + ms;
    },
    tick() {
      if (beat.style.display !== 'none' && performance.now() > beatUntil) {
        beat.style.display = 'none';
      }
    },
    setHistory(items) {
      if (!items.length) {
        panel.innerHTML = '<div class="muted">尚无事件</div>';
        return;
      }
      panel.innerHTML = items
        .map((it) => `<div class="history-item history-${it.type}">${it.text}</div>`)
        .join('');
    },
    setPovMode(isPov) {
      document.body.classList.toggle('mode-pov', !!isPov);
    },
  };
}
